import {
  CREATE_TAX_GROUP,
  GET_TAX_GROUP,
  UPDATE_TAX_GROUP,
  DELETE_TAX_GROUP,
  CREATE_TAX_TYPE,
  GET_TAX_TYPE,
  UPDATE_TAX_TYPE,
  DELETE_TAX_TYPE,
  CREATE_RETURN_TYPE,
  GET_RETURN_TYPE,
  UPDATE_RETURN_TYPE,
  DELETE_RETURN_TYPE,
  CREATE_TDS_SECTION,
  GET_TDS_SECTION,
  UPDATE_TDS_SECTION,
  DELETE_TDS_SECTION,
  CREATE_TCS_SECTION,
  GET_TCS_SECTION,
  UPDATE_TCS_SECTION,
  DELETE_TCS_SECTION,
  CREATE_TAX_MASTER,
  GET_TAX_MASTER,
  UPDATE_TAX_MASTER,
  DELETE_TAX_MASTER,
  CREATE_TAX_SLAB,
  GET_TAX_SLAB,
  UPDATE_TAX_SLAB,
  DELETE_TAX_SLAB,
  CREATE_HSN_MASTER,
  GET_HSN_MASTER,
  UPDATE_HSN_MASTER,
  DELETE_HSN_MASTER,
  CREATE_TAX_LEDGER,
  GET_TAX_LEDGER,
  UPDATE_TAX_LEDGER,
  DELETE_TAX_LEDGER,
  CREATE_TAX_SETTINGS,
  GET_TAX_SETTINGS,
  UPDATE_TAX_SETTINGS,
  DELETE_TAX_SETTINGS,
  CREATE_TAX_AUDIT,
  GET_TAX_AUDIT,
  UPDATE_TAX_AUDIT,
  DELETE_TAX_AUDIT,
} from "../actions/types";

const initialState = {
  taxGroupList: [],
  taxTypeList: [],
  returnTypeList: [],
  tdsSectionList: [],
  tcsSectionList: [],
  taxMasterList: [],
  taxSlabList: [],
  hsnMasterList: [],
  taxLedgerList: [],
  taxSettingsList: [],
  taxAuditList: [],
};

// eslint-disable-next-line import/no-anonymous-default-export
export default function (state = initialState, action) {
  switch (action.type) {
    // TAX GROUP
    case CREATE_TAX_GROUP:
      return { ...state, taxGroupSaveStatus: action.payload.success };
    case GET_TAX_GROUP:
      return { ...state, taxGroupList: action.payload.data };
    case UPDATE_TAX_GROUP:
      return { ...state, taxGroupUpdateStatus: action.payload.success };
    case DELETE_TAX_GROUP:
      return {
        ...state,
        taxGroupList: state.taxGroupList.filter(
          (item) => item.id !== action.taxGroupId,
        ),
        taxGroupDeleteStatus: action.payload.success,
      };

    // TAX TYPE
    case CREATE_TAX_TYPE:
      return { ...state, taxTypeSaveStatus: action.payload.success };
    case GET_TAX_TYPE:
      return { ...state, taxTypeList: action.payload.data };
    case UPDATE_TAX_TYPE:
      return { ...state, taxTypeUpdateStatus: action.payload.success };
    case DELETE_TAX_TYPE:
      return {
        ...state,
        taxTypeList: state.taxTypeList.filter(
          (item) => item.id !== action.taxTypeId,
        ),
        taxTypeDeleteStatus: action.payload.success,
      };

    // RETURN TYPE
    case CREATE_RETURN_TYPE:
      return { ...state, returnTypeSaveStatus: action.payload.success };
    case GET_RETURN_TYPE:
      return { ...state, returnTypeList: action.payload.data };
    case UPDATE_RETURN_TYPE:
      return { ...state, returnTypeUpdateStatus: action.payload.success };
    case DELETE_RETURN_TYPE:
      return {
        ...state,
        returnTypeList: state.returnTypeList.filter(
          (item) => item.id !== action.returnTypeId,
        ),
        returnTypeDeleteStatus: action.payload.success,
      };

    // TDS SECTION
    case CREATE_TDS_SECTION:
      return { ...state, tdsSaveStatus: action.payload.success };
    case GET_TDS_SECTION:
      return { ...state, tdsSectionList: action.payload.data };
    case UPDATE_TDS_SECTION:
      return { ...state, tdsUpdateStatus: action.payload.success };
    case DELETE_TDS_SECTION:
      return {
        ...state,
        tdsSectionList: state.tdsSectionList.filter(
          (item) => item.id !== action.tdsId,
        ),
        tdsDeleteStatus: action.payload.success,
      };

    // TCS SECTION
    case CREATE_TCS_SECTION:
      return { ...state, tcsSaveStatus: action.payload.success };
    case GET_TCS_SECTION:
      return { ...state, tcsSectionList: action.payload.data };
    case UPDATE_TCS_SECTION:
      return { ...state, tcsUpdateStatus: action.payload.success };
    case DELETE_TCS_SECTION:
      return {
        ...state,
        tcsSectionList: state.tcsSectionList.filter(
          (item) => item.id !== action.tcsId,
        ),
        tcsDeleteStatus: action.payload.success,
      };

    // TAX MASTER
    case CREATE_TAX_MASTER:
      return { ...state, taxMasterSaveStatus: action.payload.success };
    case GET_TAX_MASTER:
      return { ...state, taxMasterList: action.payload.data };
    case UPDATE_TAX_MASTER:
      return { ...state, taxMasterUpdateStatus: action.payload.success };
    case DELETE_TAX_MASTER:
      return {
        ...state,
        taxMasterList: state.taxMasterList.filter(
          (item) => item.id !== action.taxId,
        ),
        taxMasterDeleteStatus: action.payload.success,
      };

    // TAX SLAB
    case CREATE_TAX_SLAB:
      return { ...state, slabSaveStatus: action.payload.success };
    case GET_TAX_SLAB:
      return { ...state, taxSlabList: action.payload.data };
    case UPDATE_TAX_SLAB:
      return { ...state, slabUpdateStatus: action.payload.success };
    case DELETE_TAX_SLAB:
      return {
        ...state,
        taxSlabList: state.taxSlabList.filter(
          (item) => item.id !== action.slabId,
        ),
        slabDeleteStatus: action.payload.success,
      };

    // HSN MASTER
    case CREATE_HSN_MASTER:
      return { ...state, hsnSaveStatus: action.payload.success };
    case GET_HSN_MASTER:
      return {
        ...state,
        hsnMasterList: Array.isArray(action.payload)
          ? action.payload
          : action.payload?.data || [],
      };
    case UPDATE_HSN_MASTER:
      return { ...state, hsnUpdateStatus: action.payload.success };
    case DELETE_HSN_MASTER:
      return {
        ...state,
        hsnMasterList: state.hsnMasterList.filter(
          (item) => item.id !== action.hsnId,
        ),
        hsnDeleteStatus: action.payload.success,
      };

    // TAX LEDGER
    case CREATE_TAX_LEDGER:
      return { ...state, ledgerSaveStatus: action.payload.success };
    case GET_TAX_LEDGER:
      return {
        ...state,
        taxLedgerList: Array.isArray(action.payload)
          ? action.payload
          : action.payload?.data || [],
      };
    case UPDATE_TAX_LEDGER:
      return { ...state, ledgerUpdateStatus: action.payload.success };
    case DELETE_TAX_LEDGER:
      return {
        ...state,
        taxLedgerList: state.taxLedgerList.filter(
          (item) => item.id !== action.ledgerId,
        ),
        ledgerDeleteStatus: action.payload.success,
      };

    case CREATE_TAX_SETTINGS:
      return {
        ...state,
        settingsSaveStatus: action.payload.success,
        taxSettingsList: action.payload.data
          ? [...(state.taxSettingsList || []), action.payload.data]
          : state.taxSettingsList,
      };

    case GET_TAX_SETTINGS:
      return { ...state, taxSettingsList: action.payload.data || [] };

    case UPDATE_TAX_SETTINGS:
      return {
        ...state,
        settingsUpdateStatus: action.payload.success,
        taxSettingsList: action.payload.data
          ? (state.taxSettingsList || []).map((item) =>
              item.id === action.payload.data.id ? action.payload.data : item,
            )
          : state.taxSettingsList,
      };

    case DELETE_TAX_SETTINGS:
      return {
        ...state,
        taxSettingsList: (state.taxSettingsList || []).filter(
          (item) => item.id !== action.settingId,
        ),
        settingsDeleteStatus: action.payload.success,
      };

    // TAX AUDIT
    case CREATE_TAX_AUDIT:
      return {
        ...state,
        auditSaveStatus: action.payload.success,
        taxAuditList: action.payload.data
          ? [...(state.taxAuditList || []), action.payload.data]
          : state.taxAuditList,
      };

    case GET_TAX_AUDIT:
      return { ...state, taxAuditList: action.payload.data || [] };

    case UPDATE_TAX_AUDIT:
      return {
        ...state,
        auditUpdateStatus: action.payload.success,
        taxAuditList: action.payload.data
          ? (state.taxAuditList || []).map((item) =>
              item.id === action.payload.data.id ? action.payload.data : item,
            )
          : state.taxAuditList,
      };

    case DELETE_TAX_AUDIT:
      return {
        ...state,
        taxAuditList: (state.taxAuditList || []).filter(
          (item) => item.id !== action.auditId,
        ),
        auditDeleteStatus: action.payload.success,
      };

    default:
      return state;
  }
}
